<div class="propertiesContainer">
    <div class="propertiesTitleRow">
        <span style="flex: 1;">Ιδιότητες</span>
        <mat-icon (click)="close()">close</mat-icon>
    </div>

    <mat-divider></mat-divider>

    <!--  Two Step-->
    <div class="propertiesRow">
        <span style="flex: 1;">Ύπαρξη κωδικού 2 βημάτων</span>
        <span>
            <mat-slide-toggle [(ngModel)]="properties.has_two_factor"
                              [checked]="properties.has_two_factor" disabled="false"
                              color="primary">
                            </mat-slide-toggle>
        </span>
    </div>
    <div class="propertiesRow">
        <span style="flex: 1;">Επεξεργασία απο χρήστη μετά την πρώτη υποβολή</span>
        <span>
            <mat-slide-toggle [(ngModel)]="properties.canParentEdit"
                              [checked]="properties.canParentEdit" disabled="false"
                              color="primary">
                            </mat-slide-toggle>
        </span>
    </div>

    <div class="propertiesRow">
        <span style="flex: 1;">Ύπαρξη πεδίου μεταφόρτωσης αρχείων</span>
        <span>
            <mat-slide-toggle [(ngModel)]="properties.hasUploadField"
                              [checked]="properties.hasUploadField" disabled="false"
                              color="primary">
                            </mat-slide-toggle>
        </span>
    </div>
    <!---->
    <!--    Deadline-->
    <div class="propertiesRow">
        <span style="flex: 1;">Ύπαρξη προθεσμίας</span>
        <span>
            <mat-slide-toggle [(ngModel)]="properties.has_deadline" [checked]="properties.has_deadline" disabled="false"
                              color="primary">
                            </mat-slide-toggle>
        </span>
    </div>

    <div class="propertiesRow" *ngIf="properties.has_deadline">
        <span style="flex: 0.7;">Ημερομηνία προθεσμίας</span>
        <span style="flex: 0.3;">
             <mat-form-field appearance="legacy"
                             style="width:100%; font-family: 'Century Gothic', sans-serif !important;">
              <mat-label>Ημερομηνία προθεσμίας</mat-label>
              <label>
                <input [min]="minDate" matInput [matDatepicker]="picker"
                       [(ngModel)]="properties.deadline_date"
                       placeholder="Ημερομηνία προθεσμίας" readonly>
              </label>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </span>
    </div>
    <!---->
    <!--    Max Slots-->
    <div class="propertiesRow">
        <span style="flex: 1;">Κάλυψη θέσης</span>
        <span>
            <mat-slide-toggle [(ngModel)]="properties.has_max_slots" [checked]="properties.has_max_slots"
                              disabled="false"
                              color="primary">
                            </mat-slide-toggle>
        </span>
    </div>

    <div class="propertiesRow" *ngIf="properties.has_max_slots">
        <span style="flex: 0.7;">Πλήθος θέσεων</span>
        <span style="flex: 0.3;">
             <mat-form-field appearance="legacy"
                             style="width:100%; font-family: 'Century Gothic', sans-serif !important;">
              <label>
                <input matInput type="number" min="0"
                       [(ngModel)]="properties.max_slots"
                       placeholder="Πλήθος θέσεων">
              </label>
            </mat-form-field>
        </span>
    </div>
    <!--    -->
  <!--    Checkbox limit-->
  <div class="propertiesRow">
    <span style="flex: 1;">Έλεγχος checkbox</span>
    <span>
        <mat-slide-toggle [(ngModel)]="properties.checkbox_limit" [checked]="properties.checkbox_limit" disabled="false" color="primary"></mat-slide-toggle>
    </span>
  </div>

  <div class="propertiesRow" *ngIf="properties.checkbox_limit">
    <span style="flex: 0.7;">Πλήθος checkbox</span>
    <span style="flex: 0.3;">
             <mat-form-field appearance="legacy" style="width:100%; font-family: 'Century Gothic', sans-serif !important;">
              <mat-label>Πλήθος checkbox</mat-label>
              <input matInput type="number" min="0" [(ngModel)]="properties.checkbox_limit">
            </mat-form-field>
        </span>
  </div>
  <!--    -->

    <div class="propertiesTitleRow" style="margin-top: 20px;">
        <span style="flex: 1; font-weight: bold;">Επιλογές αυτοματοποιημένων ενεργειών</span>
    </div>

    <mat-divider></mat-divider>

    <!--    Automations-->
    <div *ngFor="let item of automations; let i = index">
        <div class="propertiesRow">
            <span style="flex: 1">  {{ item.description }}</span>
            <span>
            <mat-slide-toggle [(ngModel)]="item.selected" [checked]="properties.selected"
                              disabled="false"
                              color="primary">
                            </mat-slide-toggle>
        </span>
        </div>
        <div fxLayout="row" *ngIf="item.selected">
            <mat-form-field class="demo-chip-list" style="width: 100%;">
                <mat-chip-list *ngIf="i === 0" #chipList>
                    <mat-chip
                            style="background-color: var(--primary); color: white;"
                            *ngFor="let email of emails"
                            [selectable]="selectable"
                            [removable]="removable"
                            (removed)="removeEmail(email)">
                        {{email}}
                        <mat-icon matChipRemove style="color: white" *ngIf="removable">cancel</mat-icon>
                    </mat-chip>
                    <input
                            placeholder="Νέο email"
                            #emailInput
                            [formControl]="emailsCtrl"
                            [matAutocomplete]="auto"
                            [matChipInputFor]="chipList"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="addOnBlur"
                            (matChipInputTokenEnd)="addEmail($event)"
                    />
                </mat-chip-list>
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                    <mat-option *ngFor="let email of filteredEmails | async" [value]="email">
                        {{ email.email }}
                    </mat-option>
                </mat-autocomplete>

                <mat-chip-list *ngIf="i === 1" #chipList1>
                    <mat-chip
                            style="background-color: var(--primary); color: white;"
                            *ngFor="let email of emails1"
                            [selectable]="selectable"
                            [removable]="removable"
                            (removed)="removeEmail1(email)">
                        {{email}}
                        <mat-icon matChipRemove style="color: white" *ngIf="removable">cancel</mat-icon>
                    </mat-chip>
                    <input
                            placeholder="Νέο email"
                            #emailInput1
                            [formControl]="emailsCtrl1"
                            [matAutocomplete]="auto1"
                            [matChipInputFor]="chipList1"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="addOnBlur"
                            (matChipInputTokenEnd)="addEmail1($event)"
                    />
                </mat-chip-list>


                <mat-autocomplete #auto1="matAutocomplete" (optionSelected)="selected1($event)">
                    <mat-option *ngFor="let email of filteredEmails | async" [value]="email">
                        {{ email.email }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </div>
    <!---->

    <!--    Action Button-->
    <div class="propertiesRow" style="margin-top: 40px; justify-content: flex-end;">
        <span>
           <button (click)="close()" color="primary" mat-raised-button>Αποθήκευση</button>
        </span>
    </div>
    <!--    -->
</div>
